// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./consent.styl');


// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var email = require("../email/email");
var checkbox = require("../checkbox/checkbox");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var validation = require('validation')(getData).consent;
var parsing = require('parsing').consent;

function parse(text, next) {
    strip(require('raw!./consent.html'), function(outputHtml) {

        // Pick out the correct html based on the language
        var parts = outputHtml.split('<!-- language:');
        parts.shift();

        var filteredContent = null;
        for ( var i = 0, ii = parts.length; i < ii; i++ ) { 
            var part = parts[i];
            if ( part.toUpperCase().indexOf(MBGF.language.toUpperCase() + ' -->') > -1 ) {
                filteredContent = part;
                break;
            }
        }

        outputHtml = filteredContent.replace(/^(.*?)-->/, '');
        
        var match = parsing.parse(text);

        if (match) {

            // required
            if (match[1] == "*") {
                outputHtml = outputHtml.replace(/\]/g, "*]");
            }

            if (match.forced) {
                outputHtml = outputHtml.replace(/<!--  data-consent-pretext -->((.|\r|\n)*?)<!--  data-consent-pretext-end -->/g, '');
                outputHtml = outputHtml.replace(/data-module="consent"/, 'data-module="consent" data-consent-forced');
                outputHtml = outputHtml.replace(/consent-closed" data-consent-content="true"/g, 'consent-closed consent-forced" data-consent-content="true"');
            }

            text = text.replace(match[0], outputHtml);

        }

        next(text);
    });
};

function resetValidationState(context) {
    validate(context);
}

function validate(context, err) {
    // validate data-dependencies
    var ok = true;

    var checked = get(context);

    emailRe = /consentemail/;
    phoneRe = /phone/;
    postRe = /post/;

    //console.log(checked);
    if (emailRe.test(checked)) {
        // email.setRequired();
    }

    if (phoneRe.test(checked)) {
        //phone.setRequired();
    }

    if (postRe.test(checked)) {
        //post.setRequired();
    }

    return ok;
}

function admin_validate(context) {
    var ok = true;

    ok = ok && email.exists(context);

    return ok;
}

function get(context) {

    var result = checkbox.get(context);

    // We need to make a special case for consent post, since an empty value should be 
    // treated as a consent
    if (result && !result.split(',').includes('denypost')) {
        result += ',consentpost';
    }

    return result;

}

function reset(context) {
    checkbox.reset(context);
}

function init(formRoot, meta, next) {

    var context = formRoot.querySelector('[data-module="consent"]');

    if (context) {

        var content = context.querySelector('[data-consent-content="true"]');
        var button = context.querySelector('a[data-activator="true"]');

        context.isOpen = function(e) {
            var open = content.classList.contains('consent-opened');
            return open;
        };

        // Expose a function to declare if this consent is forced. A forced consent reuiqres 
        // consentemail and consentphone to have a value
        context.isForced = function() {
            var isForced = context.hasAttribute('data-consent-forced');
            return isForced;
        }

        context.toggleBox = function(e, force) {

            if (e) {
                e.preventDefault();
            }

            if (force === true || force === false) {
                if (force) {
                    content.classList.add('consent-opened');
                } else {
                    content.classList.remove('consent-opened');
                }
            } else {
                content.classList.toggle('consent-opened');
            }

            if (content.classList.contains('consent-opened')) {
                button.innerHTML = button.getAttribute('data-text-opened'); 
            } else {
                button.innerHTML = button.getAttribute('data-text-closed'); 
            }

        }

        if (button) {
            button.addEventListener('click', context.toggleBox);
        } else {
            content.classList.add('consent-opened');
        }

    }

    next(formRoot);

}

module.exports = {
    parse: parse,
    resetValidationState: resetValidationState,
    validate: validate,
    admin_validate: admin_validate,
    get: get,
    init: init,
    reset: reset
};






// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/consent/consent.js